var draft = {
    title: 'SURAT KETERANGAN HASIL PEMERIKSAAN MATA',
    subtitle: 'No. : ......../20',
	p1: 'Yang bertanda tangan dibawah ini menerangkan bahwa :',
	arr1: [
		{label:'Nama Pasien',value:''},
		{label:'Pekerjaan',value:''},
		{label:'Alamat',value:''},
		{label:'Usia',value:''},
		{label:'No. Kartu Identitas',value:''},
	],
	p2: 'Telah dilakukan pemeriksaan mata dengan hasil sebagai berikut :',
	arr2: [
		{label:'1. Tajam Penglihatan ',value:''},
		{label:`	- Mata Kiri`,value:` Dengan / Tanpa Kacamata`},
		{
			label: `	- Mata Kanan`, value: `Dengan / Tanpa Kacamata
		`},
		{
			label: '2. Penglihatan Warna:', value: `Tidak Buta Warna/ Buta Warna/ Buta Warna Parsial`},
		{label:'3. Catatan:',value:''},
	],
};
var sign = `
Pekanbaru, <tgl>

Tanda tangan Dokter Spesialis Mata
Dan Stempel Rumah Sakit



(     <nama_dokter>    )`;
import {
    headerImage
} from './headerImage.js';
import { labelValueFormatter } from './helper.js';
let arr1 = labelValueFormatter(draft.arr1,200);
let arr2 = labelValueFormatter(draft.arr2,200);
export const docContent = [{
        image: headerImage,
        width: 529
    },
    {
        text: draft.title,
        style: 'title'
    },
	{
        style: 'paragraph',
        text: draft.p1
	},
	...arr1,
	{
        style: 'paragraph',
        text: draft.p2
	},
	...arr2,
	{
		columns: [
			{text:''},
			{
				style: 'sign',
				text: sign
			}
		]
	}
];

////console.log(docContent);